import React from 'react'
import { useSorts } from '../Common/Hooks/useSorts'
import './SortToggle.css'

export interface SortToggleProps {
	canClear?: boolean
	field: string
	defaultAscending?: boolean
	label?: string
	table: string
}

export function SortToggle(props: SortToggleProps): JSX.Element {

	const { sorts, toggleSort } = useSorts()

	const tableSort = sorts.get(props.table)
	const active = !!tableSort && tableSort.field === props.field
	const arrow = !active || tableSort.ascending ? String.fromCharCode(9650) : String.fromCharCode(9660)

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className={`sort ${active ? null : 'inactive'}`} href='#' onClick={(e) => {
			e.preventDefault()
			toggleSort(props.table, props.field, props.defaultAscending, props.canClear)
		}}>
			<span className='sort-arrow'>{arrow}</span>
			{props.label && <React.Fragment>{props.label}</React.Fragment>}
		</a>
	)
}
